import { useEffect } from "react";
import Lenis from "lenis";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import About from "./components/About";
import Services from "./components/Services";
import WhyFaded from "./components/WhyFaded";
import Specials from "./components/Specials";
import Gallery from "./components/Gallery";
import Reviews from "./components/Reviews";
import AppDownload from "./components/AppDownload";
import FAQ from "./components/FAQ";
import Visit from "./components/Visit";
import Careers from "./components/Careers";
import Footer from "./components/Footer";
import MobileBar from "./components/MobileBar";
import "./App.css";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const target = document.querySelector(a.getAttribute("href"));
      if (target) {
        e.preventDefault();
        lenis.scrollTo(target, { offset: -72 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <div className="bg-background text-foreground min-h-screen">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Services />
        <WhyFaded />
        <Specials />
        <Gallery />
        <Reviews />
        <AppDownload />
        <FAQ />
        <Visit />
        <Careers />
      </main>
      <Footer />
      <MobileBar />
    </div>
  );
}
